import React, { useEffect, useState } from 'react'
import { Label, Button, Checkbox, Dimmer, Dropdown, Icon, Input, Loader, Segment, Table, TableCell, TableHeaderCell, TableRow, Popup, Modal } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import styled from 'styled-components';
import moment from 'moment';
import { EspacoTrackVendedoresAction, EspacoTrackFormulariosListAction, EspacoTrackPostLiberacaoAction, EspacoTrackGetImagemAction, EspacoTrackShowOcult, EspacoTrackFormularioOcultarAction } from '../../actions/EspacoTrackActions';
import { ToastContainer, toast } from 'react-toastify';

const StyledTable = styled(Table)`
  &&& {
    border-spacing: 0px;
    margin-bottom: 0px;
    padding: 0px 0px;

    td, th {
      border-left: none !important;
      border-right: none !important;
    }
  }    
`;

const StyledTableHeader = styled(Table.Header)`
  &&& th {
    padding: 3px 0px;
    margin: 0px 0px 0px 0px;
    background-color: #155484;
    border-left: none !important;
    border-right: none !important;
  }
`;

const StyledTableBody = styled(Table.Body)`
  &&& td {
    padding: 0px 0px !important;
    margin: 0px 0px 0px 0px !important;
    border-left: none !important;
    border-right: none !important;
  }
`;

const StyledTableCell = styled(Table.Cell)`
  &&& td {
    padding: 0px 0px !important;
    margin: 0px 0px 0px 0px !important;
    border-left: none !important;
    border-right: none !important;
  }
`;



const StyledDropdown = styled(Dropdown)`
  &&& {
    div{
        font-size:10px !important;
        width: 100% !important;
    }
    span{
        font-size:10px !important;
        width:80px !important;
    }
}`

const StyledPopupCinza = styled(Popup)`
  &&&::before {
    background-color: #f7f5ff !important; /* Substitua pela cor desejada */
  }
`;

const StyledModalHeader = styled(Modal.Header)`
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  padding-bottom: 0 !important;
  border-bottom: none !important;
`;

const ModalTitle = styled.h2`
  font-weight: 700 !important;
  margin-top: '10px' !important;
  margin-bottom: 1em !important;
`;

const StyledModalContent = styled(Modal.Content)`
  display: flex !important;
  flex-direction: column !important;
  margin-top: -30px;
  /* align-items: center !important; */
  /* text-align: center !important; */
`;

const StyledModalActions = styled(Modal.Actions)`
  display: flex !important;
  justify-content: center !important;
  gap: 1rem !important;
  padding-bottom: 2em !important;
  border-top: none !important;
  background-color: #fff !important;
`;

const JustificativaInput = React.memo(({ justificativa, setJustificativa }) => {
    return (
        <div style={{ marginTop: '20px' }}>
            <p style={{ all: 'unset', fontSize: '18px', fontWeight: 'bold' }}>
                Justificativa para liberação:
            </p>
            <textarea
                style={{ width: '100%', height: '100px', border: '1px #cacbcd solid', borderRadius: '6px', padding: '8px' }}
                value={justificativa || ''}
                onChange={(e) => setJustificativa(e.target.value)}
                maxLength={500}
            />
            <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end', alignItems: 'center' }}>
                {justificativa?.length}/500
            </div>
        </div>
    );
});

const DATA_SORT_COLUMNS = ['idfec', 'nunota', 'dtresposta', 'razaosocial', 'dt_ped'];
const ICON_SORT_COLUMNS = ['endereco', 'produtos', 'contatos', 'restricoes', 'status'];

const normalizeText = (value) => (value === undefined || value === null ? '' : String(value).trim().toLowerCase());
const normalizeFlag = (value) => (value === undefined || value === null ? '' : String(value).trim().toUpperCase());

const normalizeNumber = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
};

const normalizeDate = (value) => {
    if (!value) return null;
    const parsed = moment(value);
    return parsed.isValid() ? parsed.valueOf() : null;
};

const compareNullable = (a, b, direction) => {
    const aMissing = a === null || a === undefined || a === '';
    const bMissing = b === null || b === undefined || b === '';

    if (aMissing && bMissing) return 0;
    if (aMissing) return 1;
    if (bMissing) return -1;

    if (a < b) return direction === 'ascending' ? -1 : 1;
    if (a > b) return direction === 'ascending' ? 1 : -1;
    return 0;
};

const getChecklistColor = (item, field) => {
    const value = normalizeFlag(item?.[field]);
    const vendedor = normalizeFlag(item?.whatsemailvend);

    if (value === 'N') return 'red';
    if (value === 'S' && vendedor === 'V') return 'yellow';
    if (value === 'S') return 'green';
    return 'grey';
};

const getRestrictionSortColor = (item) => {
    const value = normalizeFlag(item?.isrestricao);
    if (value === 'S') return 'red';
    if (value === 'N') return 'green';
    return 'grey';
};

const getStatusColor = (item) => {
    if (!item) return 'grey';

    const endereco = normalizeFlag(item.isenderecocorreto);
    const produtos = normalizeFlag(item.isprodutoscorreto);
    const contatos = normalizeFlag(item.iscontatoscorreto);
    const restricao = normalizeFlag(item.isrestricao);
    const hasJustificativa = Boolean(item.justificativa && String(item.justificativa).trim() !== '');

    const missingAny = endereco === '' || produtos === '' || contatos === '' || restricao === '';
    const inverseAny =
        (endereco !== '' && endereco !== 'S') ||
        (produtos !== '' && produtos !== 'S') ||
        (contatos !== '' && contatos !== 'S');
    const allOk = endereco === 'S' && produtos === 'S' && contatos === 'S';

    if (hasJustificativa || normalizeFlag(item.whatsemailvend) === 'V') return 'yellow';
    if (inverseAny) return 'red';
    if (missingAny) return 'grey';
    if (allOk) return 'green';
    return 'grey';
};

const getIconSortColor = (item, column) => {
    if (column === 'endereco') return getChecklistColor(item, 'isenderecocorreto');
    if (column === 'produtos') return getChecklistColor(item, 'isprodutoscorreto');
    if (column === 'contatos') return getChecklistColor(item, 'iscontatoscorreto');
    if (column === 'restricoes') return getRestrictionSortColor(item);
    if (column === 'status') return getStatusColor(item);
    return 'grey';
};

const getDataSortValue = (item, column) => {
    if (column === 'idfec') return normalizeNumber(item?.idfec);
    if (column === 'nunota') return normalizeNumber(item?.nunota);
    if (column === 'dtresposta') return normalizeDate(item?.dtresposta);
    if (column === 'razaosocial') return normalizeText(item?.razaosocial);
    if (column === 'dt_ped') return normalizeDate(item?.dt_ped);
    return '';
};

const getIconPriority = (color, priority) => {
    if (priority === 'red') return color === 'red' ? 0 : 1;
    if (priority === 'green') return color === 'green' ? 0 : 1;
    return 0;
};

const isFormularioOculto = (item) => normalizeNumber(item?.is_ocult) === 1;

const sortFormularioGroups = (groups, isPrincipalValue, sortConfig) => {
    if (!sortConfig.column) return groups;

    return [...groups].sort((a, b) => {
        const principalA = a.find(isPrincipalValue) ?? a[0];
        const principalB = b.find(isPrincipalValue) ?? b[0];
        let result = 0;

        if (DATA_SORT_COLUMNS.includes(sortConfig.column)) {
            result = compareNullable(
                getDataSortValue(principalA, sortConfig.column),
                getDataSortValue(principalB, sortConfig.column),
                sortConfig.direction
            );
        } else if (ICON_SORT_COLUMNS.includes(sortConfig.column)) {
            result = compareNullable(
                getIconPriority(getIconSortColor(principalA, sortConfig.column), sortConfig.priority),
                getIconPriority(getIconSortColor(principalB, sortConfig.column), sortConfig.priority),
                'ascending'
            );
        }

        return result;
    });
};


function Formulario(props) {

    const [vendedorDropdown, setVendedorDropdown] = useState(null);
    const [openModalLiberacao, setOpenModalLiberacao] = useState(false);
    const [openModalRespota, setOpenModalResposta] = useState(false);
    const [openModalOcultar, setOpenModalOcultar] = useState(false);
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [selectedPrincipal, setSelectedPrincipal] = useState(null);
    const [selectedOcultar, setSelectedOcultar] = useState(null);
    const [justificativa, setJustificativa] = useState('');
    const [codparc, setCodparc] = useState('');
    const [nunota, setNunota] = useState('');
    const [nunotaConsultada, setNunotaConsultada] = useState('');
    const [linhasAbertas, setLinhasAbertas] = useState({});
    const [sortConfig, setSortConfig] = useState({ column: null, direction: 'ascending', priority: null });

    const { vendedores, userid, codusu, formularios, isloadingFormularios, liberacao, isliberacaoLoading, imagem, imagemloading, showOcult, isloadingFormularioOcultar } = props;
    const { EspacoTrackVendedoresAction, EspacoTrackFormulariosListAction, EspacoTrackPostLiberacaoAction, EspacoTrackGetImagemAction, EspacoTrackShowOcult, EspacoTrackFormularioOcultarAction } = props;

    useEffect(() => {
        EspacoTrackVendedoresAction(userid);
    }, []);

    const buscarFormularios = (codvend = vendedorDropdown) => {
        if (!codvend) return;

        if (showOcult === 1) {
            EspacoTrackFormulariosListAction(codvend, codparc, nunota, 0);
            EspacoTrackFormulariosListAction(codvend, codparc, nunota, 1);
            return;
        }

        EspacoTrackFormulariosListAction(codvend, codparc, nunota, 0);
    }

    const handleRefresh = () => {
        //alert(showOcult);
        setNunotaConsultada(String(nunota || '').trim());
        buscarFormularios();
    }

    const handleBuscar = () => {
        //alert(showOcult);
        setNunotaConsultada(String(nunota || '').trim());
        buscarFormularios();
    }

    const handleShowOcult = () => {
        const nextShowOcult = showOcult === 0 ? 1 : 0;
        EspacoTrackShowOcult(nextShowOcult);

        if (nextShowOcult === 1 && vendedorDropdown) {
            EspacoTrackFormulariosListAction(vendedorDropdown, codparc, nunota, 1);
        }
    }

    const handleOpenOcultar = (formulario) => {
        if (isFormularioOculto(formulario)) return;
        setSelectedOcultar(formulario);
        setOpenModalOcultar(true);
    }

    const handleConfirmOcultar = async () => {
        if (!selectedOcultar?.idfec) return;

        const result = await EspacoTrackFormularioOcultarAction(selectedOcultar.idfec);

        if (result?.[0]?.status === 'OK') {
            toast.success('Formulario ocultado com sucesso!');
            setOpenModalOcultar(false);
            setSelectedOcultar(null);
        } else {
            toast.error(result?.[0]?.mensagem || 'Erro ao ocultar formulario.');
        }
    }

    const handleCancelOcultar = () => {
        setOpenModalOcultar(false);
        setSelectedOcultar(null);
    }

    useEffect(() => {
        // Define o vendedorDropdown quando os vendedores estiverem disponíveis
        if (vendedores.length > 0) {
            setVendedorDropdown(vendedores[0]?.codvend);
        }
    }, [vendedores]); // Executa apenas quando o array "vendedores" for alterado

    useEffect(() => {
        if (vendedorDropdown) {
            buscarFormularios(vendedorDropdown);
        }
    }, [vendedorDropdown]);

    const copiarLink = async (GUID) => {
        try {
            await navigator.clipboard.writeText(`https://rastreamento.esplane.com.br/entrega/${GUID}/B`);
            toast.success('Link copiado com sucesso!');
        } catch (error) {
            toast.error('Erro ao copiar o link.');
        }
    };

    const handleSort = (column) => {
        setSortConfig((prev) => {
            if (DATA_SORT_COLUMNS.includes(column)) {
                return {
                    column,
                    direction: prev.column === column && prev.direction === 'ascending' ? 'descending' : 'ascending',
                    priority: null
                };
            }

            if (ICON_SORT_COLUMNS.includes(column)) {
                if (prev.column !== column) {
                    return { column, direction: null, priority: 'red' };
                }

                if (prev.priority === 'red') {
                    return { column, direction: null, priority: 'green' };
                }

                if (prev.priority === 'green') {
                    return { column: null, direction: 'ascending', priority: null };
                }

                return { column, direction: null, priority: 'red' };
            }

            return prev;
        });
    };

    const renderSortableHeader = (label, column, style = {}, extraProps = {}) => {
        const isActive = sortConfig.column === column;
        const iconName = ICON_SORT_COLUMNS.includes(column)
            ? sortConfig.priority === 'red' ? 'sort amount down' : sortConfig.priority === 'green' ? 'sort amount up' : 'sort'
            : sortConfig.direction === 'descending' ? 'sort amount down' : 'sort amount up';

        return (
            <TableHeaderCell
                {...extraProps}
                onClick={() => handleSort(column)}
                style={{ ...style, cursor: 'pointer', userSelect: 'none' }}
            >
                <span>{label}</span>
                {isActive && (
                    <Icon
                        name={iconName}
                        style={{ marginLeft: '4px', color: '#FFFFFF' }}
                    />
                )}
            </TableHeaderCell>
        );
    };

    const renderOcultarIcon = (formulario) => {
        const oculto = isFormularioOculto(formulario);

        return (
            <Icon
                color={oculto ? 'grey' : 'teal'}
                name="hide"
                title={oculto ? 'Formulario ja oculto' : 'Ocultar formulario'}
                onClick={oculto ? undefined : () => handleOpenOcultar(formulario)}
                style={{ cursor: oculto ? 'default' : 'pointer' }}
            />
        );
    };

    const renderNunota = (formulario) => {
        const nunotaBuscada = String(nunotaConsultada || '').trim();
        const nunotaFormulario = formulario?.nunota;
        const showNunotaBuscada = nunotaBuscada && String(nunotaFormulario || '').trim() !== nunotaBuscada;

        return (
            <span>
                {showNunotaBuscada && (
                    <span style={{ display: 'block', color: 'red', fontSize: '10px', lineHeight: '12px' }}>
                        ({nunotaBuscada})
                    </span>
                )}
                <span>{nunotaFormulario}</span>
            </span>
        );
    };


    const handleSubmitLiberacao = async () => {
        const result = await EspacoTrackPostLiberacaoAction(codusu, selectedPrincipal.idfec, justificativa);

        setOpenModalLiberacao(false); // fecha sempre após resposta

        if (result[0]?.status === 'OK') {
            toast.success('Liberação realizada com sucesso!');
            setJustificativa('');

            // atualiza lista
            EspacoTrackFormulariosListAction(vendedorDropdown, codparc, nunota);
        } else {
            toast.error('Erro ao realizar a liberação. Tente novamente.');
        }
    };

    const handleDownloadImageWithText = async () => {
        console.log('selected principal ->', selectedPrincipal);

        try {
            setLoadingDownload(true);

            const res = await EspacoTrackGetImagemAction(selectedPrincipal.idfec);

            if (!res || res.length === 0) {
                toast.error('Erro ao baixar imagem da resposta.');
                setLoadingDownload(false);
                return;
            }

            // 👉 USE A RESPOSTA DA ACTION
            const base64String = res[0]?.img_resposta;

            if (!base64String) {
                toast.error('Nenhuma imagem encontrada para baixar.');
                setLoadingDownload(false);
                return;
            }

            const linkSource = base64String.startsWith('data:')
                ? base64String
                : `data:image/png;base64,${base64String}`;

            const image = new Image();
            image.src = linkSource;

            image.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                const extraHeight = 60;

                canvas.width = image.width;
                canvas.height = image.height + extraHeight;

                ctx.drawImage(image, 0, 0);

                ctx.fillStyle = '#FFFFFF';
                ctx.fillRect(0, image.height, canvas.width, extraHeight);

                ctx.fillStyle = '#000000';
                ctx.font = '24px Arial';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';

                const text = `Respondido em ${moment(selectedPrincipal.dtresposta).format('DD/MM/YYYY')} às ${moment(selectedPrincipal.dtresposta).format('HH:mm:ss')} - IP: ${selectedPrincipal?.ip_resposta || 'N/A'}`;

                ctx.fillText(text, canvas.width / 2, image.height + extraHeight / 2);

                const newImageURL = canvas.toDataURL('image/png');

                const downloadLink = document.createElement('a');
                downloadLink.href = newImageURL;
                downloadLink.download = `resposta-${selectedPrincipal?.razaosocial || 'download'}.png`;

                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);

                setLoadingDownload(false);
            };

            image.onerror = () => {
                toast.error('Erro ao carregar imagem.');
                setLoadingDownload(false);
            };

        } catch (error) {
            console.error(error);
            toast.error('Erro inesperado ao baixar imagem.');
            setLoadingDownload(false);
        }
    };



    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} />
            <Modal open={openModalLiberacao} onClose={() => setOpenModalLiberacao(false)}>
                <StyledModalHeader>
                    <ModalTitle>Forçar Liberação</ModalTitle>
                </StyledModalHeader>

                <StyledModalContent>
                    <div>
                        <p style={{ fontSize: '22px', fontWeight: 'bold' }}>Lista de Divergências/Restrições</p>

                        {selectedPrincipal?.isenderecocorreto === 'N' && (
                            <div style={{ marginTop: '20px' }}>
                                <p style={{ all: 'unset', fontSize: '18px', fontWeight: 'bold' }}>
                                    Divergência com o endereço de entrega:
                                </p>
                                <textarea
                                    style={{ width: '100%', height: '50px', border: '1px #cacbcd solid', borderRadius: '6px', padding: '8px' }}
                                    value={selectedPrincipal?.detenderecocorreto || ''}
                                    disabled
                                    readOnly
                                />
                            </div>
                        )}

                        {/* 2. Produtos incorretos */}
                        {selectedPrincipal?.isprodutoscorreto === 'N' && (
                            <div style={{ marginTop: '20px' }}>
                                <p style={{ all: 'unset', fontSize: '18px', fontWeight: 'bold' }}>
                                    Divergência com os produtos, unidades e quantidades:
                                </p>
                                <textarea
                                    style={{ width: '100%', height: '50px', border: '1px #cacbcd solid', borderRadius: '6px', padding: '8px' }}
                                    value={selectedPrincipal?.detprodutoscorreto || ''}
                                    disabled
                                    readOnly
                                />
                            </div>
                        )}

                        {/* 3. Contatos incorretos */}
                        {selectedPrincipal?.iscontatoscorreto === 'N' && (
                            <div style={{ marginTop: '20px' }}>
                                <p style={{ all: 'unset', fontSize: '18px', fontWeight: 'bold' }}>
                                    Divergência com o WhatsApp e e-mail de quem deve receber as informações de entrega:
                                </p>
                                <textarea
                                    style={{ width: '100%', height: '50px', border: '1px #cacbcd solid', borderRadius: '6px', padding: '8px' }}
                                    value={selectedPrincipal?.detcontatoscorreto || ''}
                                    disabled
                                    readOnly
                                />
                            </div>
                        )}

                        {/* 4. Restrições */}
                        {selectedPrincipal?.isrestricao === 'S' && (
                            <div style={{ marginTop: '20px' }}>
                                <p style={{ all: 'unset', fontSize: '18px', fontWeight: 'bold' }}>
                                    Possui as seguintes restrições para o endereço de entrega:
                                </p>
                                <textarea
                                    style={{ width: '100%', height: '60px', border: '1px #cacbcd solid', borderRadius: '6px', padding: '8px' }}
                                    value={selectedPrincipal?.detrestricao || ''}
                                    disabled
                                    readOnly
                                />
                            </div>
                        )}

                        {selectedPrincipal?.justificativa ? (
                            <div style={{ marginTop: '20px' }}>
                                <p style={{ all: 'unset', fontSize: '18px', fontWeight: 'bold' }}>
                                    Justificativa do Vendedor:
                                </p>
                                <textarea
                                    style={{ width: '100%', height: '60px', border: '1px #cacbcd solid', borderRadius: '6px', padding: '8px' }}
                                    value={selectedPrincipal?.justificativa || ''}
                                    disabled
                                    readOnly
                                />
                            </div>
                        ) : (
                            <div style={{ marginTop: '20px' }}>
                                <JustificativaInput
                                    justificativa={justificativa}
                                    setJustificativa={setJustificativa}
                                />
                            </div>
                        )}


                    </div>
                    {selectedPrincipal?.justificativa ? (null) : (

                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                            <p style={{ fontSize: '18px' }}>Tem certeza que deseja liberar o pedido mesmo com Divergências/Restrições?</p>
                        </div>
                    )}
                </StyledModalContent>
                <StyledModalActions>
                    {selectedPrincipal?.justificativa ? (
                        <Button onClick={() => setOpenModalLiberacao(false)}>Fechar</Button>
                    ) : (
                        <>
                            <Button onClick={() => setOpenModalLiberacao(false)}>Cancelar</Button>
                            <Button loading={isliberacaoLoading} disabled={!justificativa} onClick={handleSubmitLiberacao} negative>Forçar Liberação</Button>
                        </>
                    )}

                </StyledModalActions>
            </Modal>
            <Modal open={openModalRespota} onClose={() => setOpenModalResposta(false)}>
                <StyledModalHeader>
                    <ModalTitle>Visualizar Respostas</ModalTitle>
                </StyledModalHeader>

                <StyledModalContent>
                    <div>
                        <p style={{ fontSize: '22px', fontWeight: 'bold' }}>Relação de respostas - {selectedPrincipal?.razaosocial} </p>

                        {selectedPrincipal?.isenderecocorreto === 'S' && (
                            <div style={{ marginTop: '20px' }}>
                                <p style={{ all: 'unset', fontSize: '18px', fontWeight: 'bold' }}>
                                    O endereço de entrega está correto? E não há nenhuma restrição?
                                </p>
                                <textarea
                                    style={{ width: '100%', height: '50px', border: '1px #cacbcd solid', borderRadius: '6px', padding: '8px' }}
                                    value={selectedPrincipal?.isenderecocorreto || ''}
                                    disabled
                                    readOnly
                                />
                            </div>
                        )}

                        {/* 2. Produtos incorretos */}
                        {selectedPrincipal?.isprodutoscorreto === 'S' && (
                            <div style={{ marginTop: '20px' }}>
                                <p style={{ all: 'unset', fontSize: '18px', fontWeight: 'bold' }}>
                                    Os produtos, unidades e quantidades estão corretos?
                                </p>
                                <textarea
                                    style={{ width: '100%', height: '50px', border: '1px #cacbcd solid', borderRadius: '6px', padding: '8px' }}
                                    value={selectedPrincipal?.isprodutoscorreto || ''}
                                    disabled
                                    readOnly
                                />
                            </div>
                        )}

                        {/* 3. Contatos incorretos */}
                        {selectedPrincipal?.iscontatoscorreto === 'S' && (
                            <div style={{ marginTop: '20px' }}>
                                <p style={{ all: 'unset', fontSize: '18px', fontWeight: 'bold' }}>
                                    O WhatsApp e e-mail de quem deve receber as informações de entrega estão corretos?
                                </p>
                                <textarea
                                    style={{ width: '100%', height: '50px', border: '1px #cacbcd solid', borderRadius: '6px', padding: '8px' }}
                                    value={selectedPrincipal?.iscontatoscorreto || ''}
                                    disabled
                                    readOnly
                                />
                            </div>
                        )}

                        {/* 4. Restrições */}
                        {/* {selectedPrincipal?.isrestricao === 'N' && (
                            <div style={{ marginTop: '20px' }}>
                                <p style={{ all: 'unset', fontSize: '18px', fontWeight: 'bold' }}>
                                    Possui as seguintes restrições para o endereço de entrega:
                                </p>
                                <textarea
                                    style={{ width: '100%', height: '60px', border: '1px #cacbcd solid', borderRadius: '6px', padding: '8px' }}
                                    value={selectedPrincipal?.detrestricao || ''}
                                    disabled
                                    readOnly
                                />
                            </div>
                        )} */}


                    </div>
                </StyledModalContent>
                <StyledModalActions>
                    <Button onClick={() => setOpenModalResposta(false)}>Cancelar</Button>
                    <Button loading={loadingDownload || imagemloading} onClick={handleDownloadImageWithText} color="green ">Baixar imagem da resposta</Button>

                </StyledModalActions>
            </Modal>
            <Modal size="mini" open={openModalOcultar} onClose={handleCancelOcultar}>
                <StyledModalHeader>
                    <ModalTitle>Ocultar Formulario</ModalTitle>
                </StyledModalHeader>
                <Modal.Content style={{ textAlign: 'center' }}>
                    <p>Tem certeza que deseja ocultar este formulario?</p>
                    {selectedOcultar?.nunota && (
                        <p style={{ color: '#175483', fontWeight: 'bold' }}>NU: {selectedOcultar.nunota}</p>
                    )}
                </Modal.Content>
                <StyledModalActions>
                    <Button icon color="green" loading={isloadingFormularioOcultar} onClick={handleConfirmOcultar}>
                        <Icon name="check" />
                    </Button>
                    <Button icon color="red" onClick={handleCancelOcultar}>
                        <Icon name="x" />
                    </Button>
                </StyledModalActions>
            </Modal>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                    <Icon onClick={handleRefresh} style={{ fontSize: '20px', marginLeft: '20px', cursor: 'pointer', color: '#175483' }} size='large' name='refresh' />

                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', width: '90px' }}>
                    <Checkbox toggle onChange={handleShowOcult} checked={showOcult === 1} />
                    <p style={{ all: 'unset', fontSize: '10px', color: '#175483' }}>Formulários ocultos</p>
                </div>
                <div style={{ width: '300px' }}>
                    <StyledDropdown
                        search
                        options={vendedores.map((item) => {
                            // Remove ESPLANE do apelido
                            const apelidoLimpo = item.apelido.replace(/ESPLANE/gi, '').trim();

                            // Verifica se contém "SUP"
                            const temSUP = item.apelido.toUpperCase().includes("SUP");

                            // Se tiver SUP → não mostra nomeger
                            const textoGerente = temSUP ? '' : `${item.nomeger} - `;

                            return {
                                key: item.codvend,
                                text: `${textoGerente}${apelidoLimpo} (${item.codvend})`,
                                value: item.codvend,
                            };
                        })}
                        selection
                        placeholder={vendedorDropdown}
                        name='vendedores'
                        fluid
                        scrolling
                        value={vendedorDropdown}
                        onChange={(e, { value }) => {
                            setVendedorDropdown(value)
                        }}
                        defaultValue={vendedorDropdown}
                    />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ fontSize: '12px' }}> Codparc:</div>
                    <Input style={{ height: '40px', marginLeft: '10px', width: '200px' }} placeholder='Código do parceiro' value={codparc} onChange={(e) => setCodparc(e.target.value)} />
                </div>
                <div style={{ display: 'flex' }}>
                    <div style={{ marginLeft: '20px', display: 'flex', flexDirection: 'row' }}>
                        <div style={{ marginTop: '10px', fontSize: '12px' }}>Consultar NU:</div>
                        <div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
                            <Input
                                style={{ marginRight: '20px' }}
                                placeholder='Digite a NU'
                                value={nunota}
                                onChange={(e) => {
                                    setNunota(e.target.value);
                                    setNunotaConsultada('');
                                }}
                            />
                        </div>
                    </div>
                </div>
                <Button onClick={handleBuscar} style={{ backgroundColor: '#155484', color: '#fff' }} ><span style={{ marginRight: '5px' }}>Buscar</span> <Icon name='search' /></Button>
            </div>

            <div style={{ display: 'flex', alignContent: 'center', marginTop: '20px', justifyContent: 'flex-end' }}>
                {/* <span style={{ marginRight: '20px' }}><b>Legenda de cores dos ícones:</b></span> */}
                <div style={{ width: '180px', height: '20px', borderTopLeftRadius: 4, borderBottomLeftRadius: 4, backgroundColor: '#21BA45', display: 'flex', justifyContent: 'center' }}>
                    <span style={{ color: '#fff', fontWeight: 'bold' }}>Sem divergência/restrição</span>
                </div>
                <div style={{ width: '200px', height: '20px', backgroundColor: 'yellow', display: 'flex', justifyContent: 'center' }}>
                    <span style={{ color: '#000', fontWeight: 'bold' }}>Respondido pelo vendedor</span>
                </div>
                <div style={{ width: '180px', height: '20px', backgroundColor: 'red', display: 'flex', justifyContent: 'center' }}>
                    <span style={{ color: '#fff', fontWeight: 'bold' }}>Com divergência/restrição</span>
                </div>
                <div style={{ width: '120px', height: '20px', backgroundColor: 'grey', borderTopRightRadius: 4, borderBottomRightRadius: 4, display: 'flex', justifyContent: 'center' }}>
                    <span style={{ color: '#fff', fontWeight: 'bold' }}>Não respondido</span>
                </div>
            </div>
            <StyledTable celled compact='very' size='small' style={{ marginTop: '15px' }}>
                <StyledTableHeader>
                    <TableRow>
                        {[2, 3, 86].includes(Number(userid)) && (
                            renderSortableHeader('IDFEC', 'idfec', { paddingLeft: '5px', color: '#FFFFFF', fontSize: '10px' })
                        )}
                        {renderSortableHeader('NU', 'nunota', { paddingLeft: '20px', color: '#FFFFFF', fontSize: '10px' })}
                        {renderSortableHeader('Dt Resposta', 'dtresposta', { color: '#FFFFFF', fontSize: '10px' })}
                        {renderSortableHeader('Parceiro', 'razaosocial', { color: '#FFFFFF', fontSize: '10px' })}
                        {renderSortableHeader('Dt Pedido', 'dt_ped', { color: '#FFFFFF', fontSize: '10px' })}
                        <TableHeaderCell width={0} style={{ textAlign: 'center', color: '#FFFFFF', fontSize: '10px', verticalAlign: 'middle' }}>
                            Responder
                        </TableHeaderCell>
                        {renderSortableHeader('Endereço', 'endereco', { color: '#FFFFFF', fontSize: '10px', textAlign: 'center' })}
                        {renderSortableHeader('Produtos', 'produtos', { color: '#FFFFFF', fontSize: '10px', textAlign: 'center' })}
                        {renderSortableHeader('Contatos', 'contatos', { color: '#FFFFFF', fontSize: '12px', textAlign: 'center' })}
                        {renderSortableHeader('Restrições', 'restricoes', { textAlign: 'center', color: '#FFFFFF', fontSize: '12px', verticalAlign: 'middle' }, { width: 0 })}
                        {renderSortableHeader('Status', 'status', { textAlign: 'center', color: '#FFFFFF', fontSize: '10px', verticalAlign: 'middle' }, { width: 0 })}
                        <TableHeaderCell width={0} style={{ textAlign: 'center', color: '#FFFFFF', fontSize: '10px', verticalAlign: 'middle' }}>
                            Ocultar
                        </TableHeaderCell>

                        <TableHeaderCell width={0} style={{ textAlign: 'center', color: '#FFFFFF', fontSize: '10px', verticalAlign: 'middle' }}>
                            Copiar (Cliente)
                        </TableHeaderCell>
                    </TableRow>
                </StyledTableHeader>

                {/* Substitua apenas o conteúdo do StyledTableBody por este */}
                <StyledTableBody>
                    {isloadingFormularios === false ? (() => {
                        // segurança: se não for array, evita crash e mostra nada
                        const lista = Array.isArray(formularios) ? formularios : [];

                        // função que detecta a chave que representa ISPRINCIPAL (tratando maiúsc/minúsc)
                        const findIsPrincipalKey = (item) => {
                            if (!item || typeof item !== 'object') return null;
                            const found = Object.keys(item).find(k => k.toLowerCase() === 'isprincipal');
                            return found || null;
                        };

                        // normaliza valor que representa "é principal"
                        const isPrincipalValue = (item) => {
                            const key = findIsPrincipalKey(item);
                            if (!key) return false;
                            const v = item[key];
                            return v === 1 || v === '1' || v === 'S' || v === 's' || v === true;
                        };

                        // agrupa por fec_guid (troque aqui se preferir agrupar por outro campo)
                        const grupos = lista.reduce((acc, item) => {
                            const gid = item.fec_guid ?? item.fecGuid ?? item.fecGuid?.toString() ?? `no-guid-${item.nunota || Math.random()}`;
                            if (!acc[gid]) acc[gid] = [];
                            acc[gid].push(item);
                            return acc;
                        }, {});

                        // se nenhum item tiver isPrincipal detectado, como fallback, mostramos todas as linhas
                        return sortFormularioGroups(Object.values(grupos), isPrincipalValue, sortConfig).map((grupo) => {
                            // se não houver principal no grupo, tentamos achar por outro critério ou usamos o primeiro como "principal" (fallback)
                            const principal = grupo.find(isPrincipalValue) ?? grupo[0];
                            const secundarias = grupo
                                .filter(i => i !== principal)
                                .sort((a, b) => new Date(b.dtresposta) - new Date(a.dtresposta));


                            // chaves únicas
                            const keyBase = principal.fec_guid ?? principal.nunota ?? Math.random().toString();

                            // estado por linha (linhasAbertas está no seu componente)
                            const aberto = linhasAbertas && linhasAbertas[keyBase];

                            const codusuCodificado = btoa(codusu);

                            return (
                                <React.Fragment key={keyBase + '_frag'}>
                                    {/* Linha principal */}
                                    <TableRow key={keyBase + '_principal'} style={{ backgroundColor: secundarias.length > 0 ? '#F7F5FF' : '#fff' }}>

                                        {[2, 3, 86].includes(Number(userid)) && (
                                            <StyledTableCell>
                                                {principal.idfec}
                                            </StyledTableCell>
                                        )}


                                        <TableCell style={{ fontSize: '12px', paddingLeft: '20px' }}>
                                            {secundarias.length > 0 && (

                                                <div style={{ position: 'relative', display: 'inline-block' }}>
                                                    <button
                                                        onClick={() =>
                                                            setLinhasAbertas(prev => ({ ...(prev || {}), [keyBase]: !prev?.[keyBase] }))
                                                        }
                                                        style={{
                                                            all: 'unset',
                                                            cursor: 'pointer',
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            paddingRight: '10px'
                                                        }}
                                                    >
                                                        <Icon name={aberto ? 'angle up' : 'angle down'} color="grey" />

                                                        <p style={{ all: 'unset', color: 'red', marginLeft: '-5px' }}>
                                                            {`+${secundarias.length}`}
                                                        </p>
                                                    </button>
                                                </div>


                                            )}
                                            {renderNunota(principal)}

                                        </TableCell>

                                        <StyledTableCell style={{ fontSize: '12px' }}>
                                            {principal.dtresposta ?
                                                moment(principal.dtresposta).format('DD/MM/YYYY HH:mm:ss')
                                                : <span style={{ color: 'red' }}>Sem Resposta</span>}
                                        </StyledTableCell>

                                        <StyledTableCell style={{ fontSize: '14px' }}>
                                            {principal.razaosocial}{principal.codparc ? `(${principal.codparc})` : ''}
                                        </StyledTableCell>

                                        <StyledTableCell style={{ fontSize: '12px' }}>
                                            {principal.dt_ped ?
                                                moment(principal.dt_ped).format('DD/MM/YYYY HH:mm:ss')
                                                : <span style={{ color: 'red' }}>Sem Resposta</span>}
                                        </StyledTableCell>


                                        <StyledTableCell style={{ fontSize: '20px', marginLeft: '20px', textAlign: 'center' }}>
                                            <button
                                                onClick={() => window.open(`https://rastreamento.esplane.com.br/entrega/${principal.fec_guid}/C?sessao=${codusuCodificado}`, '_blank')}
                                                style={{ all: 'unset', cursor: 'pointer' }}
                                            >
                                                <Icon style={{ color: '#1E88E5' }} name='file alternate' />
                                            </button>
                                        </StyledTableCell>

                                        <StyledTableCell style={{ fontSize: '20px', textAlign: 'center' }}>
                                            {principal.isenderecocorreto === 'N' ? (
                                                <StyledPopupCinza
                                                    on="hover"
                                                    hoverable
                                                    position='top right'
                                                    style={{ backgroundColor: '#f7f5ff', borderRadius: '10px', border: 'none' }}
                                                    content={
                                                        <div style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            maxHeight: '200px',
                                                            overflowY: 'auto',
                                                            padding: '10px',
                                                            scrollbarWidth: 'thin',
                                                            scrollbarColor: '#888 #f7f5ff'
                                                        }}>
                                                            <b style={{ alignSelf: 'center' }}>O endereço de entrega está correto?</b>
                                                            <br />
                                                            <p>{principal.detenderecocorreto}</p>
                                                        </div>
                                                    }
                                                    trigger={
                                                        <Icon
                                                            color='red'
                                                            name="map marker alternate"
                                                        />
                                                    }
                                                />
                                            ) : (
                                                <Icon
                                                    color={
                                                        principal.isenderecocorreto === 'S' && principal.whatsemailvend === 'V'
                                                            ? 'yellow'
                                                            : principal.isenderecocorreto === 'S' && principal.whatsemailvend !== 'V' ? 'green' : 'grey'
                                                    }
                                                    name="map marker alternate"
                                                />
                                            )}
                                        </StyledTableCell>

                                        <StyledTableCell style={{ fontSize: '20px', marginLeft: '20px', textAlign: 'center' }}>
                                            {principal.isprodutoscorreto === 'N' ? (
                                                <StyledPopupCinza
                                                    on="hover"
                                                    hoverable
                                                    position='top right'
                                                    style={{ backgroundColor: '#f7f5ff', borderRadius: '10px', border: 'none' }}
                                                    content={
                                                        <div style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            maxHeight: '200px',
                                                            overflowY: 'auto',
                                                            padding: '10px',
                                                            scrollbarWidth: 'thin',
                                                            scrollbarColor: '#888 #f7f5ff'
                                                        }}>
                                                            <b style={{ alignSelf: 'center' }}>Os produtos, unidades e quantidades estão corretos?</b>
                                                            <br />
                                                            <p>{principal.detprodutoscorreto}</p>
                                                        </div>
                                                    }
                                                    trigger={
                                                        <Icon
                                                            color="red"
                                                            name="box"
                                                        />
                                                    }
                                                />
                                            ) : (
                                                <Icon
                                                    color={
                                                        principal.isprodutoscorreto === 'S' && principal.whatsemailvend === 'V'
                                                            ? 'yellow'
                                                            : principal.isprodutoscorreto === 'S' && principal.whatsemailvend !== 'V' ? 'green' : 'grey'
                                                    }
                                                    name="box"
                                                />
                                            )}

                                        </StyledTableCell>

                                        <StyledTableCell style={{ fontSize: '20px', marginLeft: '20px', textAlign: 'center' }}>
                                            {principal.iscontatoscorreto === 'N' ? (
                                                <StyledPopupCinza
                                                    on="hover"
                                                    hoverable
                                                    position='top right'
                                                    style={{ backgroundColor: '#f7f5ff', borderRadius: '10px', border: 'none' }}
                                                    content={
                                                        <div style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            maxHeight: '200px',
                                                            overflowY: 'auto',
                                                            padding: '10px',
                                                            scrollbarWidth: 'thin',
                                                            scrollbarColor: '#888 #f7f5ff'
                                                        }}>
                                                            <b style={{ alignSelf: 'center' }}>O WhatsApp e e-mail de quem deve receber as informações de entrega estão corretos?</b>
                                                            <br />
                                                            <p>{principal.detcontatoscorreto}</p>
                                                        </div>
                                                    }
                                                    trigger={
                                                        <Icon
                                                            color="red"
                                                            name="whatsapp"
                                                        />
                                                    }
                                                />
                                            ) : (
                                                <Icon
                                                    color={
                                                        principal.iscontatoscorreto === 'S' && principal.whatsemailvend === 'V'
                                                            ? 'yellow'
                                                            : principal.iscontatoscorreto === 'S' && principal.whatsemailvend !== 'V' ? 'green' : 'grey'
                                                    }
                                                    name="whatsapp"
                                                />
                                            )}

                                        </StyledTableCell>

                                        <StyledTableCell style={{ fontSize: '20px', marginLeft: '20px', textAlign: 'center' }}>
                                            {principal.isrestricao === 'S' ? (
                                                <StyledPopupCinza
                                                    on="hover"
                                                    hoverable
                                                    position='top right'
                                                    style={{ backgroundColor: '#f7f5ff', borderRadius: '10px', border: 'none' }}
                                                    content={
                                                        <div style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            maxHeight: '200px',
                                                            overflowY: 'auto',
                                                            padding: '10px',
                                                            scrollbarWidth: 'thin',
                                                            scrollbarColor: '#888 #f7f5ff'
                                                        }}>
                                                            <b style={{ alignSelf: 'center' }}>Possui restrições de entrega?</b>
                                                            <br />
                                                            <p>{principal.detrestricao}</p>
                                                        </div>
                                                    }
                                                    trigger={
                                                        <Icon
                                                            color="red"
                                                            name="shield"
                                                        />
                                                    }
                                                />
                                            ) : (
                                                <Icon
                                                    color='grey'
                                                    name="shield"
                                                />
                                            )}

                                        </StyledTableCell>

                                        <StyledTableCell style={{ fontSize: '20px', marginLeft: '20px', textAlign: 'center' }}>
                                            {(() => {
                                                if (!principal) return <Icon color="grey" name="lock" />;

                                                const norm = (v) => (v === undefined || v === null ? '' : String(v).trim().toUpperCase());

                                                const endereco = norm(principal.isenderecocorreto);
                                                const produtos = norm(principal.isprodutoscorreto);
                                                const contatos = norm(principal.iscontatoscorreto);
                                                const restricao = norm(principal.isrestricao);

                                                const hasJustificativa = Boolean(principal.justificativa && String(principal.justificativa).trim() !== '');

                                                const expected = { endereco: 'S', produtos: 'S', contatos: 'S' };

                                                const missingAny = endereco === '' || produtos === '' || contatos === '' || restricao === '';
                                                const inverseAny =
                                                    (endereco !== '' && endereco !== expected.endereco) ||
                                                    (produtos !== '' && produtos !== expected.produtos) ||
                                                    (contatos !== '' && contatos !== expected.contatos);
                                                const allOk =
                                                    endereco === expected.endereco &&
                                                    produtos === expected.produtos &&
                                                    contatos === expected.contatos

                                                let color = 'grey';
                                                let icon = 'lock';

                                                if (hasJustificativa || principal.whatsemailvend === 'V') {
                                                    color = 'yellow';
                                                    icon = 'lock open';
                                                } else if (inverseAny) {
                                                    color = 'red';
                                                    icon = 'lock';
                                                } else if (missingAny) {
                                                    color = 'grey';
                                                    icon = 'lock';
                                                } else if (allOk) {
                                                    color = 'green';
                                                    icon = 'lock open';
                                                }

                                                // define se o ícone pode ser clicado
                                                const isClickable = color === 'red';
                                                const isClickableResp = color === 'green' || color === 'yellow';

                                                return (
                                                    <Icon
                                                        title={isClickable ? "Forçar Liberação" : isClickableResp ? "Visualizar Respostas" : "Status de bloqueio"}
                                                        onClick={isClickable ? () => { setOpenModalLiberacao(true); setSelectedPrincipal(principal); } : isClickableResp ? () => { setOpenModalResposta(true); setSelectedPrincipal(principal); } : null}
                                                        style={{ cursor: isClickable || isClickableResp ? 'pointer' : 'default' }}
                                                        color={color}
                                                        name={icon}
                                                    />
                                                );
                                            })()}
                                        </StyledTableCell>

                                        <StyledTableCell style={{ fontSize: '20px', marginLeft: '20px', textAlign: 'center' }}>
                                            {renderOcultarIcon(principal)}
                                        </StyledTableCell>

                                        <StyledTableCell style={{ fontSize: '20px', marginLeft: '20px', textAlign: 'center' }}>
                                            <button
                                                onClick={() => copiarLink(principal.fec_guid)}
                                                style={{ all: 'unset', cursor: 'pointer' }}
                                            >
                                                <Icon style={{ color: '#EC407A' }} name="copy" />
                                            </button>
                                        </StyledTableCell>


                                    </TableRow>

                                    {/* Linhas secundárias (aparecem só se aberto) */}
                                    {aberto && secundarias.map(sec => {
                                        const subKey = `${sec.fec_guid || keyBase}_sub_${sec.idfec ?? sec.nunota}`;
                                        return (
                                            <TableRow style={{ backgroundColor: '#dbdbdb' }} key={subKey}>

                                                {[2, 3, 86].includes(Number(userid)) && (
                                                    <StyledTableCell >
                                                        {sec.idfec}
                                                    </StyledTableCell>
                                                )}
                                                <TableCell style={{ fontSize: '12px', paddingLeft: '40px' }}>
                                                    {renderNunota(sec)}
                                                </TableCell>

                                                <StyledTableCell style={{ fontSize: '12px' }}>
                                                    {sec.dtresposta ? moment(sec.dtresposta).format('DD/MM/YYYY HH:mm:ss') : ''}
                                                </StyledTableCell>

                                                <StyledTableCell style={{ fontSize: '14px' }}>
                                                    {sec.razaosocial}{sec.codparc ? `(${sec.codparc})` : ''}
                                                </StyledTableCell>

                                                <StyledTableCell style={{ fontSize: '12px' }}>
                                                    {sec.dt_ped ? moment(sec.dt_ped).format('DD/MM/YYYY HH:mm:ss') : ''}
                                                </StyledTableCell>

                                                <StyledTableCell style={{ fontSize: '20px', marginLeft: '20px', textAlign: 'center' }}>
                                                    <button onClick={() => window.open(`https://rastreamento.esplane.com.br/entrega/${sec.fec_guid}/C?sessao=${codusuCodificado}`, '_blank')} style={{ all: 'unset', cursor: 'pointer' }}>
                                                        <Icon color='grey' name='file alternate' />
                                                    </button>
                                                </StyledTableCell>

                                                <StyledTableCell style={{ fontSize: '20px', textAlign: 'center' }}>
                                                    <Icon
                                                        color={sec.isenderecocorreto === 'S' && sec.whatsemailvend !== 'V' ? 'green' : sec.isenderecocorreto === 'S' && sec.whatsemailvend === 'V' ? 'yellow' : sec.isenderecocorreto === 'N' ? 'red' : 'grey'}
                                                        name="map marker alternate"
                                                    />
                                                </StyledTableCell>

                                                <StyledTableCell style={{ fontSize: '20px', marginLeft: '20px', textAlign: 'center' }}>
                                                    <Icon color={sec.isprodutoscorreto === 'S' && sec.whatsemailvend !== 'V' ? 'green' : sec.isprodutoscorreto === 'S' && sec.whatsemailvend === 'V' ? 'yellow' : sec.isprodutoscorreto === 'N' ? 'red' : 'grey'} name="box" />
                                                </StyledTableCell>

                                                <StyledTableCell style={{ fontSize: '20px', marginLeft: '20px', textAlign: 'center' }}>
                                                    <Icon color={sec.iscontatoscorreto === 'S' && sec.whatsemailvend !== 'V' ? 'green' : sec.iscontatoscorreto === 'S' && sec.whatsemailvend === 'V' ? 'yellow' : sec.iscontatoscorreto === 'N' ? 'red' : 'grey'} name="whatsapp" />
                                                </StyledTableCell>

                                                <StyledTableCell style={{ fontSize: '20px', marginLeft: '20px', textAlign: 'center' }}>
                                                    {sec.isrestricao === 'S' ? (
                                                        <StyledPopupCinza
                                                            on="hover"
                                                            hoverable
                                                            position='top right'
                                                            style={{ backgroundColor: '#f7f5ff', borderRadius: '10px', border: 'none' }}
                                                            content={
                                                                <div style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    maxHeight: '200px',
                                                                    overflowY: 'auto',
                                                                    padding: '10px',
                                                                    scrollbarWidth: 'thin',
                                                                    scrollbarColor: '#888 #f7f5ff'
                                                                }}>
                                                                    <b style={{ alignSelf: 'center' }}>Possui restrições de entrega?</b>
                                                                    <br />
                                                                    <p>{sec.detrestricao}</p>
                                                                </div>
                                                            }
                                                            trigger={
                                                                <Icon
                                                                    color="red"
                                                                    name="shield"
                                                                />
                                                            }
                                                        />
                                                    ) : (
                                                        <Icon
                                                            color='grey'
                                                            name="shield"
                                                        />
                                                    )}
                                                </StyledTableCell>

                                                <StyledTableCell style={{ fontSize: '20px', marginLeft: '20px', textAlign: 'center' }}>
                                                    {(() => {
                                                        if (!principal) return <Icon color="grey" name="lock" />;

                                                        const norm = (v) => (v === undefined || v === null ? '' : String(v).trim().toUpperCase());

                                                        const endereco = norm(sec.isenderecocorreto);
                                                        const produtos = norm(sec.isprodutoscorreto);
                                                        const contatos = norm(sec.iscontatoscorreto);
                                                        const restricao = norm(sec.isrestricao);

                                                        const hasJustificativa = Boolean(sec.justificativa && String(sec.justificativa).trim() !== '');

                                                        const expected = { endereco: 'S', produtos: 'S', contatos: 'S' };

                                                        const missingAny = endereco === '' || produtos === '' || contatos === '' || restricao === '';
                                                        const inverseAny =
                                                            (endereco !== '' && endereco !== expected.endereco) ||
                                                            (produtos !== '' && produtos !== expected.produtos) ||
                                                            (contatos !== '' && contatos !== expected.contatos);
                                                        const allOk =
                                                            endereco === expected.endereco &&
                                                            produtos === expected.produtos &&
                                                            contatos === expected.contatos

                                                        let color = 'grey';
                                                        let icon = 'lock';

                                                        if (hasJustificativa || sec.whatsemailvend === 'V') {
                                                            color = 'yellow';
                                                            icon = 'lock open';
                                                        } else if (inverseAny) {
                                                            color = 'red';
                                                            icon = 'lock';
                                                        } else if (missingAny) {
                                                            color = 'grey';
                                                            icon = 'lock';
                                                        } else if (allOk) {
                                                            color = 'green';
                                                            icon = 'lock open';
                                                        }

                                                        // define se o ícone pode ser clicado
                                                        const isClickable = color === 'red';

                                                        return (
                                                            <Icon
                                                                title="Forçar Liberação"
                                                                onClick={isClickable ? () => { setOpenModalLiberacao(true); setSelectedPrincipal(sec); } : undefined}
                                                                style={{ cursor: isClickable ? 'pointer' : 'default' }}
                                                                color={color}
                                                                name={icon}
                                                            />
                                                        );
                                                    })()}
                                                </StyledTableCell>

                                                <StyledTableCell style={{ fontSize: '20px', marginLeft: '20px', textAlign: 'center' }}>
                                                    {renderOcultarIcon(sec)}
                                                </StyledTableCell>

                                                <StyledTableCell style={{ fontSize: '20px', marginLeft: '20px', textAlign: 'center' }}>
                                                    <button onClick={() => copiarLink(sec.fec_guid)} style={{ all: 'unset', cursor: 'pointer' }}>
                                                        <Icon style={{ cursor: 'pointer' }} color='grey' name="copy" />
                                                    </button>
                                                </StyledTableCell>
                                            </TableRow>
                                        );
                                    })}
                                </React.Fragment>
                            );
                        });
                    })() : (
                        <div style={{ marginTop: '250px' }}>
                            <Loader active>Carregando...</Loader>
                        </div>
                    )}
                </StyledTableBody>


            </StyledTable>
        </>
    )
}

const mapStateToProps = (state) => ({
    userid: state.LoginReducer.userid,
    codusu: state.LoginReducer.codusu,
    vendedores: state.EspacoTrackReducer.vendedores,
    formularios: state.EspacoTrackReducer.formularios,
    isloadingFormularios: state.EspacoTrackReducer.isloadingFormularios,
    liberacao: state.EspacoTrackReducer.liberacao,
    isliberacaoLoading: state.EspacoTrackReducer.isloadingLiberacao,
    imagem: state.EspacoTrackReducer.imagem,
    imagemloading: state.EspacoTrackReducer.imagemloading,
    isloadingFormularioOcultar: state.EspacoTrackReducer.isloadingFormularioOcultar,
    showOcult: state.EspacoTrackReducer.showOcult
})

export default withRouter(connect(mapStateToProps, {
    EspacoTrackVendedoresAction,
    EspacoTrackFormulariosListAction,
    EspacoTrackPostLiberacaoAction,
    EspacoTrackGetImagemAction,
    EspacoTrackShowOcult,
    EspacoTrackFormularioOcultarAction
}
)(Formulario));
